import React from 'react';
import { PageTitleZoneNext } from '../../../../components/page-title-zone';

export interface IClassroomTitlezoneProps {
  isEditMode: boolean;
}

export function ClassroomTitlezone(props: IClassroomTitlezoneProps) {
  const { isEditMode } = props;
  const title = isEditMode ? 'Redigér lokale' : 'Opret lokale';
  return <PageTitleZoneNext isLoading={false} entityName="Lokale" title={title} />;
}
